import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { stringIsNullOrEmpty } from '../../util/strings';
import Spinner from '../Spinner';

export default withStyles({})(({ variant, topText, data, bottomText, loading }) => {
    let cssVariant = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `data--${variant}`;

    return (
        <div className="data-highlight">
            <p>{topText}</p>
            <p className={`data ${cssVariant || ''}`}>{(!!loading && <Spinner />) || data}</p>
            <p>{bottomText}</p>
        </div>
    );
});
